module.exports = __webpack_public_path__ + "static/media/payment-flow.39e8135e.png";